import Network from '@/Network'
import { AuthorizationResourcesAndSubjects, AuthorizationRelations } from '@/types/authorization'
import { UpsertPermissionsRequest } from '@/Network/Types/Requests/AuthorizationRequests'
import { ModuleTypeStrategy, PermissionOption } from './ModuleTypeStrategy'

const PERMISSIONS_FOR_NEW_USERS: PermissionOption[] = [
  { label: 'Operação', value: AuthorizationRelations.Operator },
  { label: 'Tático', value: AuthorizationRelations.MedicalCoordinator },
  { label: 'Análise de Risco', value: AuthorizationRelations.AuditAnalyst },
  { label: 'Técnica', value: AuthorizationRelations.TechnicalValidator },
  { label: 'Estratégica', value: AuthorizationRelations.StrategicValidator },
  { label: 'Executiva', value: AuthorizationRelations.ExecutiveValidator }
]

const PERMISSIONS_FOR_SELECT: PermissionOption[] = [
  { label: 'Proprietário', value: AuthorizationRelations.Parent, disabled: true },
  { label: 'Operação', value: AuthorizationRelations.Operator },
  { label: 'Tático', value: AuthorizationRelations.MedicalCoordinator },
  { label: 'Análise de Risco', value: AuthorizationRelations.AuditAnalyst },
  { label: 'Técnica', value: AuthorizationRelations.TechnicalValidator },
  { label: 'Estratégica', value: AuthorizationRelations.StrategicValidator },
  { label: 'Executiva', value: AuthorizationRelations.ExecutiveValidator }
]

export class StationExceptionalitiesStrategy implements ModuleTypeStrategy {
  getPermissionsForNewUsers(): PermissionOption[] {
    return PERMISSIONS_FOR_NEW_USERS
  }

  getPermissionsForSelect(): PermissionOption[] {
    return PERMISSIONS_FOR_SELECT
  }

  getDefaultPermission(): AuthorizationRelations {
    return AuthorizationRelations.Operator
  }

  resolveResourceType(base: AuthorizationResourcesAndSubjects): AuthorizationResourcesAndSubjects {
    if (base === AuthorizationResourcesAndSubjects.Company)
      return AuthorizationResourcesAndSubjects.StationExceptionalitiesCompany
    if (base === AuthorizationResourcesAndSubjects.HealthUnit)
      return AuthorizationResourcesAndSubjects.StationExceptionalitiesHealthUnit
    return AuthorizationResourcesAndSubjects.StationExceptionalitiesSchedule
  }

  async addPermissions(
    resourceId: number,
    companyId: number,
    payload: UpsertPermissionsRequest,
    resourceType: AuthorizationResourcesAndSubjects
  ): Promise<void> {
    switch (resourceType) {
      case AuthorizationResourcesAndSubjects.StationExceptionalitiesCompany:
        await Network.permission.addStationExceptionalityToCompany(resourceId, payload)
        break
      case AuthorizationResourcesAndSubjects.StationExceptionalitiesHealthUnit:
        await Network.permission.addStationExceptionalityToHealthUnit(
          resourceId,
          companyId,
          payload
        )
        break
      case AuthorizationResourcesAndSubjects.StationExceptionalitiesSchedule:
        await Network.permission.addStationExceptionalityToSchedule(resourceId, companyId, payload)
        break
    }
  }

  async upsertPermissions(
    resourceId: number,
    companyId: number,
    payload: UpsertPermissionsRequest,
    resourceType: AuthorizationResourcesAndSubjects
  ): Promise<void> {
    switch (resourceType) {
      case AuthorizationResourcesAndSubjects.StationExceptionalitiesCompany:
        await Network.permission.upsertStationExceptionalityToCompany(resourceId, payload)
        break
      case AuthorizationResourcesAndSubjects.StationExceptionalitiesHealthUnit:
        await Network.permission.upsertStationExceptionalityToHealthUnit(
          resourceId,
          companyId,
          payload
        )
        break
      case AuthorizationResourcesAndSubjects.StationExceptionalitiesSchedule:
        await Network.permission.upsertStationExceptionalityToSchedule(
          resourceId,
          companyId,
          payload
        )
        break
    }
  }
}
